module.exports = __webpack_public_path__ + "img/collection-engagementRingsBudgetLow@2x.40f4714.jpg";